namespace TabAurous.OMS {
    export interface FormatMasterRow {
        FormatId?: number;
        FormatType?: string;
        StartIndex?: number;
        Separator?: string;
        Prefix?: string;
        PrefixDate?: string;
        PrefixCode?: string;
        Suffix?: string;
        DesignPrefix?: string;
        DesignPrefixEditor?: string[];
        DesignSuffix?: string;
        DesignSuffixEditor?: string[];
        Format?: string;
        IncrementBy?: number;
        LastNumber?: number;
        PrefillwithZero?: boolean;
        Noofzeroes?: number;
        BranchWise?: boolean;
        CounterWise?: boolean;
        Lock?: boolean;
        ResetMonthly?: boolean;
        ResetYearly?: boolean;
        LastMonth?: number;
        LastYear?: number;
        Num1?: number;
        Num2?: number;
        Num3?: number;
        String1?: string;
        String2?: string;
        String3?: string;
        Sys_Date?: string;
    }

    export namespace FormatMasterRow {
        export const idProperty = 'FormatId';
        export const nameProperty = 'FormatType';
        export const localTextPrefix = 'OMS.FormatMaster';
        export const lookupKey = 'OMS.FormatMaster';

        export function getLookup(): Q.Lookup<FormatMasterRow> {
            return Q.getLookup<FormatMasterRow>('OMS.FormatMaster');
        }
        export const deletePermission = 'Administration:Format Master:Delete';
        export const insertPermission = 'Administration:Format Master:Add';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            FormatId = "FormatId",
            FormatType = "FormatType",
            StartIndex = "StartIndex",
            Separator = "Separator",
            Prefix = "Prefix",
            PrefixDate = "PrefixDate",
            PrefixCode = "PrefixCode",
            Suffix = "Suffix",
            DesignPrefix = "DesignPrefix",
            DesignPrefixEditor = "DesignPrefixEditor",
            DesignSuffix = "DesignSuffix",
            DesignSuffixEditor = "DesignSuffixEditor",
            Format = "Format",
            IncrementBy = "IncrementBy",
            LastNumber = "LastNumber",
            PrefillwithZero = "PrefillwithZero",
            Noofzeroes = "Noofzeroes",
            BranchWise = "BranchWise",
            CounterWise = "CounterWise",
            Lock = "Lock",
            ResetMonthly = "ResetMonthly",
            ResetYearly = "ResetYearly",
            LastMonth = "LastMonth",
            LastYear = "LastYear",
            Num1 = "Num1",
            Num2 = "Num2",
            Num3 = "Num3",
            String1 = "String1",
            String2 = "String2",
            String3 = "String3",
            Sys_Date = "Sys_Date"
        }
    }
}
